
import { AloDbUser } from '@/models/alodb/AloDbUser'
import { FilterUser } from '@/models/filter/FilterUser';
import { AloDbRoleMapping } from '@/models/alodb/AloDbRoleMapping';

export interface IUserState {
    status:string
    users: Array<AloDbUser>
    modifiedAdmUser: AloDbUser
    originalAdmUser: AloDbUser            
    modifiedAdmUserRolesMapping: Array<AloDbRoleMapping>
    userLoading: boolean
    roleMappingLoading: boolean
    roleMappingLoadingByType: {[type:string]:boolean}
    adminFilter: FilterUser    
}
  
const state:IUserState = { 
    status: '',
    users: [],
    modifiedAdmUser: new AloDbUser(),
    originalAdmUser: new AloDbUser(),
    modifiedAdmUserRolesMapping: [],
    userLoading:false,
    roleMappingLoading:false,
    roleMappingLoadingByType:{},
    adminFilter: new FilterUser()    
}
  
export default state